import React, { useState, useEffect } from 'react';
import { navigate } from '@reach/router';
import { Link } from 'gatsby';
import { Container } from './nav.css';

const Nav = () => {
  const [isNavBarToggle, setIsNavBarToggle] = useState(false);

  const handleClick = () => {
    isNavBarToggle ? setIsNavBarToggle(false) : setIsNavBarToggle(true);
  };

  return (
    <Container className="navbar-container">
      <span className={`navbar flexible vertical ${isNavBarToggle ? 'close' : 'hide'}`}
           onClick={handleClick} onKeyDown={handleClick} 
           role="button" 
           tabIndex={0}
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </span>
      <ul className={`flexible horizontal ${isNavBarToggle ? 'open' : 'ulclose'}`}>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/blogs">Blogs</Link>
        </li>
        <li>
          <a href="https://github.com/ruddhani">GitHub</a>
        </li>
      </ul>
    </Container>
  );
}

export default Nav;
